import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import React from 'react';

type Props = {
  size?: FontAwesomeIconProps['size'];
};

export const Loader: React.FC<React.PropsWithChildren<Props>> = ({ size = 'lg' }) => {
  return (
    <span className="loader">
      <FontAwesomeIcon icon={'circle-notch'} spin size={size} />
    </span>
  );
};
